import React from "react";
import GoogleTracking from "../../services/GoogleTracking";
import appPath from "../../utils/appPath";
import forceCircularTabbing from "../../utils/forceCircularTabbing";

class DefaultLayout extends React.Component {
    constructor(props) {
        super(props);
        this.previousLocation = {
            pathname: "",
            href: ""
        };
    }

    render() {
        return (
            <div className="default-layout" ref="root">
                { this.props.children }
            </div>
        );
    }

    _document() {
        return document;
    }

    _trackPageView() {
        const _document = this._document();

        // [DX] 8/10/16 This gets around the extra PUSH calls when the same page gets updated
        if (this.previousLocation && this.previousLocation.pathname === _document.location.pathname) {
            return;
        }

        const dimensions = {
            referrer: this.previousLocation.href || _document.referrer
        };

        GoogleTracking.recordPageView(dimensions);

        this.previousLocation = {
            pathname: _document.location.pathname,
            href: _document.location.href
        };
    }

    // [DX] 7/22/16 both componentDidMount and componentDidUpdate need to call trackPageView
    // componentDidMount: gets called when user first navigates to app
    // componentDidUpdate: gets called when user navigates to another page
    componentDidMount() {
        this._trackPageView();
        this.props.setCountryFromIP();

        if (appPath.isIframePath()) {
            forceCircularTabbing();
        }
    }

    componentDidUpdate() {
        this._trackPageView();
    }
}

export default DefaultLayout;
